import { render, staticRenderFns } from "./Yewu.vue?vue&type=template&id=e561b18a&scoped=true&"
import script from "./Yewu.vue?vue&type=script&lang=js&"
export * from "./Yewu.vue?vue&type=script&lang=js&"
import style0 from "./Yewu.vue?vue&type=style&index=0&id=e561b18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e561b18a",
  null
  
)

export default component.exports